// @flow

import stores from 'stores';

export default (firstName: string, lastName: string, email: string) => {
  return stores.parcelsStore.getParcelsByUser(firstName, lastName, email);
};
